/* PPF-Kits: EasySearch YMM controller
   - Phones (< 750px) on product pages WITH a [data-ppf-ymm-open] button ("Change vehicle" in the product head):
     the widget moves into a bottom-sheet <dialog> inside its slot. Product pages without such a button keep the inline card.
   - Desktop (>= 750px): own toggle collapses the panel to a compact heading row; product pages start collapsed
   - Phones on other pages: the widget is a card that STARTS COLLAPSED. The controller owns that state for the
     app's vertical accordion (below 480px) and for its horizontal mode (480-749px), where the app has no accordion:
     one real button over the header row, aria-expanded, and CSS that ignores the app's own max-height writes.
     That also removes the app's resize bug (it closes every widget on an address-bar resize).
   - Prefill once the app has loaded: the product's own vehicle, otherwise the last vehicle searched with Find Kit (30 days)
   Config: window.PPF_YMM_CFG (snippets/ppf-ymm.liquid). Pre-paint: snippets/ppf-ymm-head.liquid.
   Styles: assets/ppf-ymm.css (mechanics) + assets/ppf-ymm-suchleiste.css (phone card look) */
(function () {
  'use strict';
  if (window.__ppfYmmInit) { unpend(); return; } // loaded twice: still lift the pre-paint classes
  window.__ppfYmmInit = true;

  var CFG = window.PPF_YMM_CFG || {};
  var T = CFG.i18n || {};
  var root = document.documentElement;
  var IS_PRODUCT = CFG.template === 'product';
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CAN_DIALOG = typeof HTMLDialogElement === 'function' && typeof HTMLDialogElement.prototype.showModal === 'function';
  var TRIGGER = '[data-ppf-ymm-open]';
  var LAST_KEY = 'ppf-ymm-last-vehicle';
  var LAST_MS = 30 * 24 * 3600 * 1000;
  var ICON_CHEVRON = '<svg class="ppf-ymm-toggle__icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var S = null;
  var loadedSeen = false; // the app fires easysearch_loaded BEFORE it sets eventStates.easysearch_loaded

  // document.documentElement, not root: this also runs before the var block (double include)
  function unpend() { document.documentElement.classList.remove('ppf-ymm-pending', 'ppf-ymm-pending-sheet', 'ppf-ymm-pending-card'); }

  // Theme editor: never move or hide the widget (fail open)
  if (window.Shopify && window.Shopify.designMode) { unpend(); return; }

  function ES() { var e = window.easysearch; return e && e.eventStates ? e : null; }
  function mode() { return S ? S.slot.getAttribute('data-ppf-ymm') : ''; }
  function onChange(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn); }
  function firstSelect() { return S.holder.querySelector('.easysearch-field-select-holder select:not(:disabled)') || S.holder.querySelector('select:not(:disabled)'); }
  function focusEl(el) { if (!el || typeof el.focus !== 'function') return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  /* ---------- Setup, once the app has rendered the form ---------- */
  function setup() {
    if (S) return;
    var widget = document.querySelector('#MainContent .easysearch-block-container > .easysearch-main-widget');
    if (!widget) { unpend(); return; }
    var container = widget.querySelector('.easysearch-container');
    var holder = container && container.querySelector('.easysearch-holder');
    if (!holder || !holder.querySelector('select')) return; // not rendered yet
    var block = widget.parentElement;
    var slot = block.parentElement;
    if (!holder.id) holder.id = 'ppf-ymm-fields';

    var home = document.createComment('ppf-ymm-home');
    slot.insertBefore(home, block);

    // both toggles sit in the panel, never inside .easysearch-header-holder (the app rewrites it on resize)
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ppf-ymm-toggle';
    toggle.setAttribute('aria-controls', holder.id);
    toggle.innerHTML = '<span class="ppf-ymm-toggle__label"></span>' + ICON_CHEVRON;
    container.insertBefore(toggle, container.firstChild);

    // phones: a real button covering the card header row (the app's header is a div with a click listener)
    var head = container.querySelector('.easysearch-header-holder');
    var ptoggle = document.createElement('button');
    ptoggle.type = 'button';
    ptoggle.className = 'ppf-ymm-ptoggle';
    ptoggle.setAttribute('aria-controls', holder.id);
    ptoggle.setAttribute('aria-expanded', 'false');
    if (head && head.textContent.trim()) {
      if (!head.id) head.id = 'ppf-ymm-heading';
      ptoggle.setAttribute('aria-labelledby', head.id); // the app keeps this element and only rewrites its text
    } else {
      ptoggle.setAttribute('aria-label', T.show || 'Show search');
    }
    container.insertBefore(ptoggle, container.firstChild);

    S = { slot: slot, block: block, container: container, holder: holder, home: home, toggle: toggle,
          label: toggle.firstChild, head: head, ptoggle: ptoggle, collapsed: IS_PRODUCT, cardOpen: false,
          tw: 0, dlg: null, body: null, title: null };

    toggle.addEventListener('click', function () { setCollapsed(!S.collapsed, true); });
    ptoggle.addEventListener('click', function () { setCardOpen(!S.cardOpen, true); });
    container.addEventListener('click', function (e) {
      var m = mode();
      if ((m === 'collapsed' || m === 'expanded') && e.target.closest('.easysearch-header-holder')) setCollapsed(!S.collapsed, true);
    });

    onChange(PHONE, applyMode);
    applyMode();
    unpend();
    showTriggers();
    watchTriggers();
    // web fonts change the label widths: measure the pill again
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { S.tw = 0; sizeToggle(); });
    prefill();
  }

  function buildDialog() {
    var dlg = document.createElement('dialog');
    dlg.className = 'ppf-ymm-dialog';
    dlg.id = 'ppf-ymm-dialog';
    dlg.setAttribute('aria-labelledby', 'ppf-ymm-dialog-title');
    dlg.setAttribute('tabindex', '-1'); // takes the focus on tap, so the first Tab reaches the close button
    dlg.innerHTML = '<div class="ppf-ymm-dialog__head"><h2 class="ppf-ymm-dialog__title" id="ppf-ymm-dialog-title"></h2>' +
      '<button type="button" class="ppf-ymm-dialog__close">' + ICON_X + '</button></div><div class="ppf-ymm-dialog__body"></div>';
    S.title = dlg.querySelector('.ppf-ymm-dialog__title');
    S.title.textContent = T.title || 'Change vehicle';
    var close = dlg.querySelector('.ppf-ymm-dialog__close');
    close.setAttribute('aria-label', T.close || 'Close');
    close.addEventListener('click', function () { dlg.close(); });
    // tap on the backdrop (outside the sheet box) closes
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
    dlg.addEventListener('close', onDialogClose);
    S.slot.appendChild(dlg);
    S.dlg = dlg;
    S.body = dlg.querySelector('.ppf-ymm-dialog__body');
  }

  /* ---------- Modes: popup | native (phones) · collapsed | expanded (desktop) ---------- */
  // the sheet needs something that opens it: without a trigger the page keeps the inline card
  function sheetWanted() {
    return IS_PRODUCT && CAN_DIALOG && PHONE.matches && !!document.querySelector(TRIGGER);
  }

  function applyMode() {
    if (!S) return;
    if (sheetWanted()) {
      if (!S.dlg) buildDialog();
      if (S.block.parentNode !== S.body) S.body.appendChild(S.block);
      setMode('popup');
      return;
    }
    // leaving the sheet while it is open (rotation, a window resize across 750px):
    // the search stays open where the sheet was, instead of collapsing behind the pill
    if (S.dlg && S.dlg.open) { S.collapsed = false; S.cardOpen = true; S.silent = true; S.dlg.close(); }
    if (S.block.parentNode !== S.slot) S.slot.insertBefore(S.block, S.home.nextSibling);
    setMode(PHONE.matches ? 'native' : (S.collapsed ? 'collapsed' : 'expanded'));
  }

  function setMode(m) {
    S.slot.setAttribute('data-ppf-ymm', m);
    if (m === 'collapsed' || m === 'expanded') {
      var open = m === 'expanded';
      S.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      S.label.textContent = open ? (T.hide || 'Hide search') : (T.show || 'Show search');
      sizeToggle();
    }
    if (m === 'native') {
      S.slot.setAttribute('data-ppf-ymm-card', S.cardOpen ? 'open' : 'closed');
      S.ptoggle.setAttribute('aria-expanded', S.cardOpen ? 'true' : 'false');
      if (S.head) S.head.setAttribute('aria-hidden', 'true'); // the button carries the same name
    } else {
      S.slot.removeAttribute('data-ppf-ymm-card');
      if (S.head) S.head.removeAttribute('aria-hidden');
    }
    ariaTriggers();
  }

  // pill width = the wider of both labels, so it never moves when the label changes
  function sizeToggle() {
    var m = mode();
    if (S.tw || (m !== 'collapsed' && m !== 'expanded')) return;
    var cur = S.label.textContent;
    var w = 0;
    S.slot.style.setProperty('--ppf-ymm-tw', '0px');
    [T.show || 'Show search', T.hide || 'Hide search'].forEach(function (t) {
      S.label.textContent = t;
      w = Math.max(w, S.toggle.getBoundingClientRect().width);
    });
    S.label.textContent = cur;
    S.tw = Math.ceil(w);
    if (S.tw) S.slot.style.setProperty('--ppf-ymm-tw', S.tw + 'px');
    else S.slot.style.removeProperty('--ppf-ymm-tw');
  }

  // fields fade in when the user opens them
  function reveal() {
    S.slot.classList.remove('ppf-ymm-reveal');
    void S.slot.offsetWidth;
    S.slot.classList.add('ppf-ymm-reveal');
    clearTimeout(S.revealTimer);
    S.revealTimer = setTimeout(function () { S.slot.classList.remove('ppf-ymm-reveal'); }, 400);
  }

  function setCollapsed(c, user) {
    S.collapsed = c;
    if (PHONE.matches) return;
    setMode(c ? 'collapsed' : 'expanded');
    if (!c && user) reveal();
  }

  // phones, inline card: our own open state, so no resize of the app can close it
  function setCardOpen(open, user) {
    S.cardOpen = open;
    if (mode() !== 'native') return;
    setMode('native');
    if (open && user) reveal();
  }

  /* ---------- Bottom sheet ---------- */
  function openDialog(trigger, keyboard) {
    var d = S.dlg;
    if (!d || d.open) return;
    S.returnFocus = trigger || document.activeElement;
    S.silent = false;
    d.showModal();
    lock(true);
    S.body.scrollTop = 0;
    ariaTriggers();
    // keyboard: straight into the first field; tap/click: the sheet itself, so no focus ring sits on a prefilled field
    focusEl((keyboard && firstSelect()) || d);
  }

  function onDialogClose() {
    lock(false);
    ariaTriggers();
    var t = S.returnFocus;
    S.returnFocus = null;
    if (!S.silent && t && t.isConnected) focusEl(t);
    S.silent = false;
  }

  // Scroll lock through our own class only: html.ppf-ymm-locked sets overflow:hidden on html (the scroller
  // here) and body. Dawn's body.overflow-hidden belongs to the drawers, so we never write or remove it.
  function lock(on) {
    root.classList.toggle('ppf-ymm-locked', on);
  }

  /* ---------- "Change vehicle" trigger ---------- */
  function openFrom(t, keyboard) {
    var m = mode();
    if (m === 'popup') { openDialog(t, keyboard); return; }
    if (m === 'collapsed') setCollapsed(false, true);
    if (m === 'native') setCardOpen(true, true);
    scrollToPanel();
    flash();
    if (keyboard) focusEl(firstSelect());
  }

  function scrollToPanel() {
    var r = S.container.getBoundingClientRect();
    var vh = window.innerHeight;
    var header = document.querySelector('.section-header');
    var stickyH = header && /sticky|fixed/.test(getComputedStyle(header).position) ? header.offsetHeight : 0;
    var covered = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    // already fully in view below the header: do not move the page (it would also hide an on-scroll-up header)
    if (r.top >= covered && r.bottom <= vh) return;
    var y = window.pageYOffset;
    var top = r.top + y - 16;
    var sticky = document.querySelector('sticky-header');
    var type = sticky ? sticky.getAttribute('data-sticky-type') : '';
    // room for a sticky header, unless it hides while scrolling down or the panel would not fit below it (landscape phones)
    if (stickyH && !(type === 'on-scroll-up' && top > y) && r.height + stickyH + 32 <= vh) top -= stickyH;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCE.matches ? 'auto' : 'smooth' });
  }

  function flash() {
    var el = S.block;
    clearTimeout(S.flashTimer);
    clearTimeout(S.flashEnd);
    el.classList.remove('ppf-ymm-flash');
    S.flashTimer = setTimeout(function () {
      void el.offsetWidth;
      el.classList.add('ppf-ymm-flash');
      S.flashEnd = setTimeout(function () { el.classList.remove('ppf-ymm-flash'); }, 2400);
    }, REDUCE.matches ? 0 : 450);
  }

  // what the trigger does in the current mode, for screen readers
  function ariaTriggers() {
    if (!S) return;
    var m = mode();
    var list = document.querySelectorAll(TRIGGER);
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (m === 'popup') {
        b.setAttribute('aria-haspopup', 'dialog');
        b.setAttribute('aria-controls', S.dlg.id);
        b.setAttribute('aria-expanded', S.dlg.open ? 'true' : 'false');
      } else {
        b.removeAttribute('aria-haspopup');
        b.setAttribute('aria-controls', S.holder.id);
        if (m === 'native') b.setAttribute('aria-expanded', S.cardOpen ? 'true' : 'false');
        else if (m === 'collapsed' || m === 'expanded') b.setAttribute('aria-expanded', m === 'expanded' ? 'true' : 'false');
        else b.removeAttribute('aria-expanded');
      }
    }
  }

  function showTriggers() {
    var list = document.querySelectorAll(TRIGGER + '[hidden]');
    for (var i = 0; i < list.length; i++) list[i].hidden = false;
    ariaTriggers();
  }

  function containsTrigger(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType === 1 && (n.matches(TRIGGER) || (n.firstElementChild && n.querySelector(TRIGGER)))) return true;
    }
    return false;
  }

  // product-info re-renders can bring the button back with [hidden]; only added nodes that carry a trigger count
  function watchTriggers() {
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (!containsTrigger(records[i].addedNodes)) continue;
        showTriggers();
        if (mode() !== 'popup') applyMode();
        return;
      }
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest(TRIGGER) : null;
    if (!t) return;
    e.preventDefault();
    if (S) openFrom(t, e.detail === 0);
  });

  // #ymm / #ymm-search jump links (home, brand pages): open first, their own handler scrolls
  document.addEventListener('click', function (e) {
    if (!S) return;
    var a = e.target.closest ? e.target.closest('a[href$="#ymm"], a[href="#ymm-search"]') : null;
    if (!a || a.pathname !== location.pathname) return;
    var m = mode();
    if (m === 'collapsed') setCollapsed(false, true);
    else if (m === 'native') setCardOpen(true, true);
    else if (m === 'popup') { e.preventDefault(); e.stopImmediatePropagation(); openDialog(a, e.detail === 0); }
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && S && S.dlg && S.dlg.open) { S.silent = true; S.dlg.close(); }
  });

  /* ---------- Prefill: product vehicle, else the last Find Kit search ---------- */
  // remember the vehicle of every Find Kit click (link navigation, the app fires this right before)
  document.addEventListener('easysearch_params_saved', function (e) {
    var h = e.detail && e.detail.holder;
    var idx = h && h.esparams ? h.esparams.index : '';
    if (typeof idx !== 'string' || !idx.replace(/,/g, '')) return;
    try { localStorage.setItem(LAST_KEY, JSON.stringify({ index: idx, ts: Date.now() })); } catch (err) { /* storage blocked */ }
  });

  function lastVehicle() {
    try {
      var v = JSON.parse(localStorage.getItem(LAST_KEY) || 'null');
      if (v && typeof v.index === 'string' && typeof v.ts === 'number' && Date.now() - v.ts < LAST_MS) return v.index;
    } catch (err) { /* storage blocked or invalid */ }
    return '';
  }

  // only full tree paths have a collection URL (intermediate indexes return option names)
  function leafUrl(E, idx) {
    var u = idx ? E.getUrlByIndex(idx) : '';
    return typeof u === 'string' && /^(\/|https?:)/.test(u) ? u : '';
  }

  // kits for exactly one vehicle (one EasySearch vehicle tag); accessories fit many
  function productVehicle(E) {
    if (!IS_PRODUCT || typeof E.fitmentGetFirstReferencedTreeIndex !== 'function') return '';
    var tags = E.pageInfo && E.pageInfo.productTagsSet ? Array.from(E.pageInfo.productTagsSet) : [];
    if (tags.filter(function (t) { return /-esi\d+$/i.test(t); }).length !== 1) return '';
    return E.fitmentGetFirstReferencedTreeIndex() || '';
  }

  // runs once after easysearch_loaded; no focus, no mode change, and it never opens the card
  function prefill() {
    var E = ES();
    if (!S || S.filled || !E || !(loadedSeen || E.eventStates.easysearch_loaded)) return;
    S.filled = true;
    try {
      var form = E.settings && E.settings.form;
      if (!form || form.main_autosubmit || typeof E.searchFormFillAllSelects !== 'function') return;
      if (E.getCurrentIndex(S.holder).replace(/,/g, '')) return; // chosen already, e.g. the app's own preselect after Find Kit
      var idx = productVehicle(E);
      if (!leafUrl(E, idx)) idx = lastVehicle();
      if (!leafUrl(E, idx)) return; // vehicle no longer in the tree
      E.searchFormFillAllSelects(S.holder, idx.split(',').slice(0, E.settings.fields.length));
    } catch (err) { /* keep the form empty */ }
  }

  /* ---------- Keep-open guard for widgets we do not control ---------- */
  // The app closes its accordion on EVERY resize, also when only the address bar moves.
  // Inside our card the state is ours (the header button intercepts the clicks), so this only
  // matters if the controller never took over, e.g. a widget outside the expected markup.
  var userToggleAt = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.easysearch-main-widget .easysearch-header-holder')) userToggleAt = Date.now();
  }, true);

  function guard(c) {
    if (c.__ppfKeepOpen || typeof MutationObserver !== 'function') return;
    c.__ppfKeepOpen = true;
    var widthAtOpen = c.classList.contains('easysearch-opened') ? window.innerWidth : null;
    new MutationObserver(function (records) {
      // records arrive batched: any of them may carry the class the app has just removed
      var wasOpen = false;
      for (var i = 0; i < records.length; i++) {
        if ((records[i].oldValue || '').indexOf('easysearch-opened') !== -1) { wasOpen = true; break; }
      }
      var isOpen = c.classList.contains('easysearch-opened');
      if (!wasOpen && isOpen) { widthAtOpen = window.innerWidth; return; }
      if (!wasOpen || isOpen) return;
      if (Date.now() - userToggleAt < 700) return;
      if (!c.classList.contains('easysearch-vertical-mode')) return;
      if (window.innerWidth !== widthAtOpen) return;
      if (c.closest('.ppf-ymm-dialog') || c.closest('[data-ppf-ymm-card]')) return;
      var h = c.querySelector('.easysearch-holder');
      c.classList.add('easysearch-opened');
      if (h) h.style.maxHeight = h.scrollHeight + 'px';
    }).observe(c, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  function guardAll() {
    var list = document.querySelectorAll('#MainContent .easysearch-main-widget .easysearch-container');
    for (var i = 0; i < list.length; i++) guard(list[i]);
  }

  /* ---------- Boot (the app may render before or after this script) ---------- */
  document.addEventListener('easysearch_rendered', function () { setup(); guardAll(); });
  document.addEventListener('easysearch_loaded', function () { loadedSeen = true; setup(); prefill(); });

  function boot() {
    var E = ES();
    if (E && E.eventStates.easysearch_rendered) setup();
    else if (!document.querySelector('#MainContent .easysearch-block-container')) unpend();
    guardAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
